export default "__VITE_ASSET__BLEi8YCb__"